export class GlobalPeerGroupList {
  peerId: number;
  peerLabel: string;
  action: boolean;
}
